export const HIDE = true;
export const TEXT_INPUT_TYPE = 'text';
export const EMAIL_INPUT_TYPE = 'email';
export const PASSWORD_INPUT_TYPE = 'password';
export const OTP_INPUT_TYPE = 'text';

export const NEW_PASSWORD_VISIBILITY = false;
export const CONFIRM_PASSWORD_VISIBILITY = false;
export const VISIBILITY_OFF_ICON = 'visibility_off_outline';
export const VISIBILITY_ICON = 'visibility_outline';
export const LOCK_ICON = 'lock_outline';
export const PREFIX_INPUT_ICON = 'home';
export const MAIL_ICON = 'mail_outline';
export const ACCOUNT_CIRCLE_ICON = 'account_circle';
export const PHONE_ICON = 'phone_iphone';

export const FNAME_LABEL = $localize`First Name`;
export const LNAME_LABEL = $localize`Last Name`;
export const EMAIL_LABEL = $localize`Email`;
export const PHN_LABEL = $localize`Phone Number`;
export const ORGNAME_LABEL = $localize`Organization Name`;
export const PASSWORD_LABEL_NEW = $localize`New Password`;
export const PASSWORD_LABEL_CONFIRM = $localize`Confirm Password`;

export const FNAME_PLACEHOLDER = $localize`Your first name`;
export const LNAME_PLACEHOLDER = $localize`Your last name`;
export const EMAIL_PLACEHOLDER = $localize`Your email`;
export const PHN_PLACEHOLDER = $localize`(+123) 9876543210`;
export const ORGNAME_PLACEHOLDER = $localize`Your Organization name`;
export const PHN_STYLE = 'example-full-width';
export const BTN_STYLE_FILLED_LARGE_DISABLED = 'btn-filled-large-disabled';

export const NEXT_BTN = 'mat-stepper-next';

export const BUTTON_ONE = $localize`Next`;
export const BUTTON_TWO = $localize`Continue`;
export const BUTTON_THREE = $localize`Signup`;
export const BTN_MAT_FLAT = 'mat-flat-button';
export const BTN_STYLE_FILLED_LARGE = 'btn-filled-large';
export const SUBMIT_DISABLED = true;

export const POPUP_TITLE = $localize`User has been created successfully. Admin has to approve before you can login.`;
export const POPUP_OK = $localize`OK`;
export const POPUP_CANCEL = $localize`Cancel`;

export const CHEVRON_ICON = 'chevron_left';
export const ARIA_HIDDEN = 'false';
export const ARIA_LABEL = 'chevron left';
export const OTP_ERROR: boolean = false;
export const ORG_ERROR: boolean = false;
export const USER_CREATION_FAILED = $localize`Email already exists.`;
export const BACK_LABEL = $localize`Back`;

export const CRITERIA_1 = $localize`Password must be between 8 and 32 characters`;
export const CRITERIA_2 = $localize`Must contain an uppercase character`;
export const CRITERIA_3 = $localize`Must contain a number`;
export const CRITERIA_4 = $localize`Must contain one special character`;

export const RESEND_CODE = $localize`Resend Code`;
